// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem } from '@/components';
import { Button, Input, TextEditor } from '@/ui';

// Models
import { ISettlementData } from '@/models/prices.model';

// Helpers
import { PricesFormValues, TSettlementFormValues } from '../../helpers';
import { useSettlementFormRules } from '../../hooks';

type TSettlementFormProps = {
  onSubmit: (values: TSettlementFormValues) => void;
  formName?: string;
  initialValues?: ISettlementData;
};

export const SettlementForm = ({ onSubmit, formName, initialValues }: TSettlementFormProps) => {
  const rules = useSettlementFormRules();
  const { t } = useTranslation('prices');

  return (
    <Form onFinish={onSubmit} name={formName} initialValues={initialValues}>
      <FormItem name={PricesFormValues.NAME_EN} rules={rules[PricesFormValues.NAME_EN]} label={t('label_title_en')}>
        <Input />
      </FormItem>
      <FormItem name={PricesFormValues.NAME_NO} rules={rules[PricesFormValues.NAME_NO]} label={t('label_title_no')}>
        <Input />
      </FormItem>
      <FormItem
        name={PricesFormValues.DESCRIPTION_EN}
        rules={rules[PricesFormValues.DESCRIPTION_EN]}
        label={t('label_description_en')}
      >
        <TextEditor />
      </FormItem>
      <FormItem
        name={PricesFormValues.DESCRIPTION_NO}
        rules={rules[PricesFormValues.DESCRIPTION_NO]}
        label={t('label_description_no')}
      >
        <TextEditor />
      </FormItem>
      <Button htmlType={'submit'} type={'primary'}>
        {t('button_update')}
      </Button>
    </Form>
  );
};

export default SettlementForm;
